<template>
  <v-card class="fill-height" width="100vw" :loading="loading">
    <v-card-title>
      <v-tabs v-model="tabs" grow>
        <v-tab
        v-for="item in items"
        :key="item"
        >
          {{ item }}
        </v-tab>
      </v-tabs>
      guid: {{ shop.guid }}
    </v-card-title>
    <v-card-text>
      <v-tabs-items
        v-model="tabs"
      >
        <v-tab-item :value="0">
          <v-row>
            <v-col cols="12" md="6" lg="6">
              <General v-model="shop" :original_value="original_value"/>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <Prodelivery v-model="shop" :original_value="original_value"/>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <PaymentSettings v-model="payment_agent"/>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <v-card outlined>
                <v-card-title>Изображение для магазина</v-card-title>
                <v-img v-if="shop.logo_image" :src="`/media/images/${shop.logo_image}?size=lg`">
                  <v-badge top left color="warning" overlap dot :value="shop.logo_image != original_value.logo_image">
                    <v-btn class="ma-2" small color="secondary" fab @click="shop.logo_image = null"><v-icon>mdi-delete</v-icon></v-btn>
                  </v-badge>
                </v-img>
                <ImageCropper v-else
                  @onResult="onImageData"
                  :aspectRatio="1"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item :value="1">
          <v-btn class="mb-3" color="primary" @click="downloadHtml">Скачать HTML</v-btn>
          <v-textarea
            name="template"
            label="Шаблон"
            filled
            disabled
            auto-grow
            :value="generatedCode"
          ></v-textarea>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ImageCropper from "@/components/image-cropper/ImageCropper.vue";
import General from './settings/General.vue';
import Prodelivery from './settings/Prodelivery.vue';
import PaymentSettings from './settings/PaymentSettings.vue';

export default{

  props: {
    loading: Boolean,
    value: Object,
    original_value: Object
  },

  data: ()=>({
    tabs: null,
    items: ['Основные', 'Генератор']
  }),

  computed:{
    ...mapGetters('data', ['template']),
    shop: {
      set(v){
        this.$emit('input', v)
      },
      get(){
        return this.value
      }
    },

    payment_agent: {
      set(v){
        this.$emit('input', {...this.value, payment_agent: v})
      },
      get(){
        return this.value.payment_agent
      }
    },

    generatedCode(){
      const parser = new DOMParser();
      let html = parser.parseFromString(this.template, "text/html")
      let div = html.querySelector('#app')
      if(div)
        div.setAttribute('corporation', this.shop.corporation_id)
      return html.documentElement.innerHTML
    }
  },

    mounted() {
    console.log('payment_agent', this.payment_agent)
  },

  methods:{
    ...mapActions('data', ['process_image']),

    async onImageData(data){
      let form = new FormData();
      form.append('image', data.image);
      form.append('crop', JSON.stringify(data.crop));
      this.loading = false;
      let res = await this.process_image(form);
      if (res) {
        this.shop.logo_image = res;
      }
      this.loading = true;
    },
    downloadHtml() {
      const blob = new Blob([this.generatedCode], { type: 'text/html' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'index.html');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  },

  components:{
    General,
    Prodelivery,
    ImageCropper,
    PaymentSettings
  }
}
</script>